
define('text!ui/template/content/content.html',[],function () { return '<div html="getContentUnsanitizedHtml()" css="$data.additionalClasses" visible="visible"></div><div data-role="spinner" class="admin__data-grid-loading-mask" visible="loading" if="showSpinner"><div class="spinner"><span repeat="8"></span></div></div>';});

